import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { patientFlowsActions } from 'features/patientFlows';

const usePatientFlows = () => {
  const dispatch = useDispatch();
  const getPatientFlow = useCallback(() => dispatch(patientFlowsActions.getPatientFlow()), [dispatch]);
  const createPatientFlow = useCallback(patient_flow => dispatch(patientFlowsActions.createPatientFlow(patient_flow)), [dispatch]);
  const updatePatientFlow = useCallback(patient_flow => dispatch(patientFlowsActions.updatePatientFlow(patient_flow)), [dispatch]);
  const deletePatientFlow = useCallback(() => dispatch(patientFlowsActions.deletePatientFlow()), [dispatch]);
  const clearLocalActivePatientFlow = useCallback(() => dispatch(patientFlowsActions.clearLocalActivePatientFlow()), [dispatch]);

  return {
    getPatientFlow,
    createPatientFlow,
    updatePatientFlow,
    deletePatientFlow,
    clearLocalActivePatientFlow
  };
};

export default usePatientFlows;